// The phone value the contact forms validate. It is set by the phone input's
// onChange (as mobile_phone_number.value) only once the user types, so a number
// pre-filled from the account profile -- {callingCode, phoneNumber}, or just a
// phoneNumber string -- has no `value` and used to read as "no valid phone" until
// the user edited it.
export const getContactPhoneValue = ({ mobile_phone_number, phoneNumber } = {}) => {
  if (mobile_phone_number?.value) return mobile_phone_number.value;
  if (mobile_phone_number?.phoneNumber) {
    return `${mobile_phone_number.callingCode || ''}${mobile_phone_number.phoneNumber}`;
  }
  return phoneNumber || null;
};
